{
  "_meta": {
    "asOf": "2025-01",
    "source": "Tax Foundation 'State and Local Sales Tax Rates, 2025' (combined state + average local rate). DC excluded — not a state.",
    "schema": "combined is the effective combined state + avg local sales tax rate as a decimal"
  },
  "AL": {"combined": 0.0929}, "AK": {"combined": 0.0181}, "AZ": {"combined": 0.0838}, "AR": {"combined": 0.0945},
  "CA": {"combined": 0.0885}, "CO": {"combined": 0.0781}, "CT": {"combined": 0.0635}, "DE": {"combined": 0.0000}, "DC": {"combined": 0.0600},
  "FL": {"combined": 0.0700}, "GA": {"combined": 0.0742}, "HI": {"combined": 0.0450}, "ID": {"combined": 0.0603},
  "IL": {"combined": 0.0886}, "IN": {"combined": 0.0700}, "IA": {"combined": 0.0694}, "KS": {"combined": 0.0875},
  "KY": {"combined": 0.0600}, "LA": {"combined": 0.0956}, "ME": {"combined": 0.0550}, "MD": {"combined": 0.0600},
  "MA": {"combined": 0.0625}, "MI": {"combined": 0.0600}, "MN": {"combined": 0.0804}, "MS": {"combined": 0.0707},
  "MO": {"combined": 0.0839}, "MT": {"combined": 0.0000}, "NE": {"combined": 0.0697}, "NV": {"combined": 0.0824},
  "NH": {"combined": 0.0000}, "NJ": {"combined": 0.0660}, "NM": {"combined": 0.0762}, "NY": {"combined": 0.0853},
  "NC": {"combined": 0.0700}, "ND": {"combined": 0.0704}, "OH": {"combined": 0.0724}, "OK": {"combined": 0.0899},
  "OR": {"combined": 0.0000}, "PA": {"combined": 0.0634}, "RI": {"combined": 0.0700}, "SC": {"combined": 0.0750},
  "SD": {"combined": 0.0640}, "TN": {"combined": 0.0955}, "TX": {"combined": 0.0820}, "UT": {"combined": 0.0720},
  "VT": {"combined": 0.0636}, "VA": {"combined": 0.0577}, "WA": {"combined": 0.0943}, "WV": {"combined": 0.0657},
  "WI": {"combined": 0.0570}, "WY": {"combined": 0.0544}
}
